import React from 'react';
import Reflux from 'reflux';
import './Comment.css';
import {Link} from 'react-router-dom';

export default class TopicBoxRelated extends Reflux.Component {
    render () {
        return <div className='box'>
          <h5>Populares en este tópico</h5>
          <ul className='users-popular'>
            {
            this.props.relatedTopics
            .filter((relatedTopic) => relatedTopic.createdBy && relatedTopic.createdBy.username)
            .map((relatedTopic, index) => {
                return <li key={index} >
                  <div className='image-content'>
                    <Link to={`/p/${relatedTopic.createdBy.username}`}>
                      <object type='image/jpg' data={relatedTopic.createdBy ? relatedTopic.createdBy.profile_image.sizeSmall : '/images/icons/default.jpg'}>
                        <img src='/images/icons/default-big.jpg' />
                      </object>
                    </Link>
                  </div>
                  <div className='txt-user-popular'>
                    <Link to={`/topic/${relatedTopic.id}_usertopic`} >
                      <h5 className='truncate'>{relatedTopic.createdBy.screen_name}</h5>
                      <span>Ver su Top5 ></span>
                    </Link>
                  </div>
                </li>;
            })
          }
          </ul>
        </div>;
    }
  };



// WEBPACK FOOTER //
// ./src/sections/TopicBoxRelated.js